import "./SectionTitle.scss";

const SectionTitle = ({ title }) => {
	return <h2 className="title">{title}</h2>;
};

export default SectionTitle;
